interface InstitutionType {
  name: string
  guid: string
  subtitle?: string
}

interface AccountType {
  institution_guid?: string
}

interface SubtitleLabel {
  plural: string
  singular: string
}

/**
 * This function is to filter and map the institutions array by adding the number of associated accounts
 * based on the `guid` from the accounts array.
 * @param institutions - The list of institutions.
 * @param accounts - The list of accounts linked to institutions.
 * @param subtitleLabel - Determines subtitle based on the number of accounts.
 * @returns - The updated institutions array with account count.
 */
export const getInstitutionsBasedOnGuid = (
  institutions: InstitutionType[],
  accounts: AccountType[],
  subtitleLabel: SubtitleLabel,
) => {
  const accountCountMap = accounts.reduce<Record<string, number>>((acc, { institution_guid }) => {
    acc[institution_guid!] = (acc[institution_guid!] || 0) + 1
    return acc
  }, {})
  return institutions
    .filter(({ guid }) => !!accountCountMap[guid])
    .map(({ guid, ...rest }) => {
      const subtitle = `${accountCountMap[guid]} ${
        accountCountMap[guid] === 1 ? subtitleLabel.singular : subtitleLabel.plural
      }`

      return {
        ...rest,
        guid,
        subtitle,
      }
    })
}
